import { render, staticRenderFns } from "./brand-models-slider.vue?vue&type=template&id=0b0f4e16&scoped=true&"
import script from "./brand-models-slider.vue?vue&type=script&lang=js&"
export * from "./brand-models-slider.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=0b0f4e16&scoped=true&lang=css&"
import style1 from "./brand-models-slider.vue?vue&type=style&index=1&id=0b0f4e16&scoped=true&lang=css&"
import style2 from "./brand-models-slider.vue?vue&type=style&index=2&id=0b0f4e16&scoped=true&lang=css&"
import style3 from "./brand-models-slider.vue?vue&type=style&index=3&id=0b0f4e16&scoped=true&lang=css&"
import style4 from "./brand-models-slider.vue?vue&type=style&index=4&id=0b0f4e16&scoped=true&lang=css&"
import style5 from "./brand-models-slider.vue?vue&type=style&index=5&lang=css&"
import style6 from "./brand-models-slider.vue?vue&type=style&index=6&id=0b0f4e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f4e16",
  null
  
)

export default component.exports